import type { BrowserAuth } from "@bindery/auth-consumer/browser";

// The broker re-mints the user_session with `readerId` stamped, and
// `includeReaders` keeps the roster on it so the picker survives the bind.
export function bindReaderThrough(
  signIn: BrowserAuth["signIn"],
  readerId: string,
  returnTo?: string,
): void {
  signIn(returnTo, { readerId, includeReaders: true });
}
